var map = {
	"./components/BookSlider.vue": 5426,
	"./components/BuscadorGeneralComponent.vue": 8840,
	"./components/CardMasBuscados.vue": 3558,
	"./components/CardOpensearch.vue": 9547,
	"./components/CarritoHeader.vue": 248,
	"./components/CountrySelect.vue": 7877,
	"./components/InputSpinner.vue": 7318,
	"./components/InputSpinnerResumen.vue": 3134,
	"./components/ModalColegio.vue": 2218,
	"./components/ModalComunidad.vue": 5079,
	"./components/Opensearch.vue": 180,
	"./components/ResultadosComponent.vue": 8042,
	"./components/ResultadosOpensearch.vue": 7147,
	"./components/ToastNotification.vue": 7935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5763;